"use client";

import { Link as LinkIcon, Sparkles, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  label: "Step 01 / Understand",
  title: "Understand your data and objectives",
  body: "We review your available information, reporting requirements, and the business questions you need to answer before defining the most suitable analytical approach.",
  Icon: LinkIcon
}, {
  label: "Step 02 / Prepare & Analyse",
  title: "Organise and analyse the information",
  body: "We clean, structure, validate, and analyse your data to identify important trends, variances, risks, and opportunities.",
  Icon: Sparkles
}, {
  label: "Step 03 / Present",
  title: "Deliver clear and useful insight",
  body: "We present the results through practical reports, dashboards, and visual summaries that make complex information easier to understand and use.",
  Icon: TrendingUp
}];
export default function Insight() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const card0 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const card1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const card2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const cardRefs = [card0, card1, card2];
  return;
}